import React from 'react'
import { LocalizationContextType } from '../../shared/contexts'
import { formatTenantDateTime } from '../../../utils/formatTenantDateTime'
import { TIME_SOURCE, timeSourceTitle } from '../../../utils/timeSource'
import { formatTemperature, temperatureUnit } from '../../../utils/formatTemperature'

interface SensorLog {
  id: number
  sensor_id: string
  sensor_title: string
  recorded_value: number
  recorded_at: string
}

interface SensorLogsTableProps {
  sensor_logs: SensorLog[]
  localization_context?: LocalizationContextType
}

const SensorLogsTable: React.FC<SensorLogsTableProps> = ({ sensor_logs, localization_context }) => {
  const formatDate = (dateString: string) => formatTenantDateTime(dateString, localization_context)

  return (
    <table className="table table-robis">
      <thead className="thead-robis">
        <tr>
          <th scope="col">Date & Time</th>
          <th scope="col">Sensor ID</th>
          <th scope="col">Sensor Title</th>
          <th scope="col">Value ({temperatureUnit(localization_context)})</th>
        </tr>
      </thead>
      <tbody>
        {sensor_logs.map((log) => (
          <tr key={log.id}>
            <td>
              <div className="small" title={timeSourceTitle(log.recorded_at, TIME_SOURCE.app)}>
                {formatDate(log.recorded_at)}
              </div>
            </td>
            <td>
              <code className="small">{log.sensor_id}</code>
            </td>
            <td>
              <span>{log.sensor_title}</span>
            </td>
            <td>
              <span className="small">
                {formatTemperature(log.recorded_value, localization_context)}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default SensorLogsTable
